<template>
  <div class="liveMatchesTwoTitleDialog">
    <el-dialog
      :title="$t('live.setting')"
      :visible.sync="isShowLiveSet"
      :show-close="false"
      :lock-scroll="false"
      width="625px"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="formInline"
        label-position="left"
        label-width="auto"
        :rules="rulesFrom"
        ref="ruleForm"
      >
        <el-form-item
          :label="$t('pc.matchSelect')"
          v-if="detail.category === 2"
        >
          <el-select
            v-model="formInline.match"
            filterable
            :placeholder="$t('pc.matchSelectPlace')"
            style="width: 300px"
            @change="selectMatch"
          >
            <el-option
              v-for="item in MatchComp"
              :key="item.id"
              :label="item.comp"
              :value="item.comp"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pc.selectSess')" v-if="detail.category === 2">
          <el-select
            v-model="formInline.session"
            :placeholder="$t('pc.selectSessPlace')"
            style="width: 300px"
            @change="chooseSession"
          >
            <!-- <el-select v-model="formLive.session" placeholder="请选择场次" style="width: 300px"> -->
            <el-option
              v-for="(item, index) in dateMatch"
              :key="index"
              :label="item.home ? `${item.home}-${item.away}` : ''"
              :value="item.match_id"
            ></el-option>
            <!-- <el-option
              v-for="item in dateSession"
              :key="item.id"
              :label="item.hometeam.name_zh ? `${item.hometeam.name_zh}-${item.awayteam.name_zh}` : ''"
              :value="item.id"
            ></el-option> -->
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="清晰度选择" v-if="detail.category === 2">
          <el-select v-model="formInline.definition" placeholder="请选择清晰度" style="width: 300px" @change="chooseDefinition">
            <el-option v-for="item in definitions" :key="item.code" :label="item.label" :value="item.url"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="直播地址" style="margin-bottom: 15px" v-if="detail.category === 2">
          <el-input v-model.trim="formInline.liveStream" placeholder="获取直播地址" style="width: 300px" :disabled="true"></el-input>
          <span class="append_text" @click="doCopy(formInline.liveStream)" v-if="formInline.liveStream">一键复制</span>
        </el-form-item> -->
        <el-form-item :label="$t('feedback.title')" prop="title">
          <el-input
            v-model="formInline.title"
            :placeholder="$t('video.tipTitle')"
            style="width: 300px"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('live.changeImg')" prop="imageUrl">
          <el-upload
            :multiple="false"
            :before-upload="beforeAvatarUpload"
            :http-request="handleUpload"
            class="upload-demo"
            :action="'/asd'"
            :auto-upload="true"
            :show-file-list="false"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            v-loading="upLoading"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              class="imgurl"
              style="width: 160px; height: 90px"
            />
            <div v-else>
              <!--
				      <i class="el-icon-circle-plus-outline" style="font-size: 30px; color: #ccc"></i>
							-->
              <img width="40" :src="require('@/assets/live/camera.png')" />
              <div class="upload-text">{{ $t("live.upload") }}</div>
            </div>
            <div
              v-if="imageUrl"
              class="del"
              style="left: 176px"
              @click.stop="removeImage(0)"
            >
              {{ $t("img.delete") }}
            </div>
            <div class="el-upload__text" style="left: 176px">
              <div class="size">{{ $t("live.imgSize") }}</div>
              <div class="format">{{ $t("live.imgConfig") }}</div>
            </div>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="高速推流" style="margin-bottom: 15px">
          <span class="pull-stream">
            <span>{{
              formLive.web_rtc_push_url ? "******" : "请输入推流地址"
            }}</span>
            <span
              class="append_text"
              @click="doCopy(formLive.web_rtc_push_url)"
              v-if="formLive.web_rtc_push_url"
              >一键复制</span
            >
          </span>
        </el-form-item> -->
        <el-form-item :label="$t('live.push')" style="margin-bottom: 15px">
          <span class="pull-stream">
            <span>{{
              formLive.whip1 ? "******" : $t("video.pushAddress")
            }}</span>
            <span
              class="append_text"
              @click="doCopy(formLive.whip1)"
              v-if="formLive.whip1"
              >{{ $t("video.copy") }}</span
            >
          </span>
        </el-form-item>
        <el-form-item :label="$t('video.key')" style="margin-bottom: 15px">
          <span class="pull-stream">
            <span>{{
              formLive.anchor_secret ? "******" : $t("video.keyPlace")
            }}</span>
            <span
              class="append_text"
              @click="doCopy(formLive.anchor_secret)"
              v-if="formLive.anchor_secret"
              >{{ $t("video.copy") }}</span
            >
          </span>
        </el-form-item>
        <el-form-item :label="$t('video.recordingInfoKey')" style="margin-bottom: 15px">
          <span class="pull-stream">
            <span>{{
              formLive.web_rec_push_url ? "******" : $t("video.pushAddress2Input")
            }}</span>
            <span
              class="append_text"
              @click="doCopy(formLive.web_rec_push_url)"
              v-if="formLive.web_rec_push_url"
              >{{ $t("video.copy") }}</span
            >
          </span>
        </el-form-item>
        <!-- <el-form-item label="消耗入场券/人" prop="ticket">
          <el-input
            v-model="formInline.ticket"
            placeholder="请输入观看入场券数量"
            type="number"
            pattern="/^-?\d+\.?\d*$/"
            onKeyPress="if(this.value.length==4) return false;"
            style="width: 300px"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="btn cancle_btn" @click="resetForm('ruleForm')">
          {{ $t("user.cancelText") }}
        </div>
        <div class="btn confirm_btn" @click="confirm('ruleForm')">
          {{ $t("info.save") }}
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../../util/http";
import moment from "moment";
import { mapState } from "vuex";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";
export default {
  mixins: [uploadByCosSdk],
  name: "liveMatchesTwoTitleDialog",
  inject: ["reload"],

  props: {
    title: {
      type: String,
      default: "",
    },
    isShowLiveSet: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    activeCategory: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  data() {
    return {
      uploadUrl:
        ENV === "dev" ? "/proxy/api/user/file" : API_URL + "/api/user/file",
      rulesFrom: {
        title: [
          {
            required: true,
            message: this.$t("video.tipTitle"),
            trigger: "blur",
          },
        ],
        // imageUrl_v: [{ required: true, message: "竖版封面不能为空", trigger: "change" }],
        imageUrl: [
          {
            required: true,
            message: this.$t("video.tipImg"),
            trigger: "change",
          },
        ],
      },
      formInline: {
        match: "",
        definition: "",
        liveStream: "",
        title: this.title,
        session: "",
        imageUrl_v: "",
        imageUrl: "",
        ticket: "",
      },
      imageUrl_v: "",
      imageUrl: "",
      match_id: 0,
      dateSession: [],
      definitions: [],
      MatchComp: [],
      dateMatch: [],
      streamUrl: "",
      formLive: "",
      upLoading_v: false,
      upLoading: false,
      myHeaders: {},
    };
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        if (newValue && newValue.category === 2) {
          const { matchid } = newValue;
          this.match_id = matchid;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.getSportMatch();
    this.getSportMatchComp();

    this.getStreamInfo();
    // console.log("this.detail: ",this.detail)
    if (this.detail && this.detail.thumb) {
      this.imageUrl = this.detail.thumb || "";
      this.formInline.imageUrl = this.detail.thumb || "";
    }
  },
  methods: {
    getStreamInfo() {
      post({
        // 获取推流地址
        url: "/webapi/live/getStreamInfo",
      }).then(({ data: { data } }) => {
        this.formLive = data;
      });
    },
    async getSportMatchComp() {
      const {
        data: { data },
      } = await post({
        url: "/api/match/getSportMatchComp",
        data: {
          sport_id: this.activeCategory,
        },
      });
      this.MatchComp = data.sport_live_match_comp;
    },
    async getSportMatch(comp) {
      const {
        data: { data },
      } = await post({
        url: "/api/match/getSportMatch",
        data: {
          comp: comp,
          sport_id: this.activeCategory,
        },
      });
      this.dateMatch = data.sport_live_match;
    },
    async getStreamUrl() {
      const {
        data: { data },
      } = await post({
        url: "/api/live/editLive",
        data: {
          sport_id: this.activeCategory,
        },
      });
      this.streamUrl = data.sport_live_match;
    },
    selectMatch(e) {
      // let dateSession = this.dateMatch.find((item) => item.id === e);
      // this.dateSession = dateSession.matchs || [];
      // this.dateSession.push(this.dateMatch[e.split(",")[1]]);
      this.formInline.session = "";
      this.formInline.liveStream = "";
      this.getSportMatch(e);
    },
    getLabel(key) {
      return key === "pushurl3"
        ? this.$t("video.en")
        : key === "pushurl2"
        ? this.$t("video.zh")
        : this.$t("video.normal");
    },
    chooseSession(e) {
      this.match_id = e;
      // this.formInline.definition = "";
      // this.formInline.liveStream = "";
      // post({
      //   // 获取直播地址
      //   url: "/webapi/sport/getPullUrl",
      //   data: {
      //     match_id: parseInt(e),
      //     request_time: moment().unix(),
      //     type: "football",
      //   },
      // }).then(({ data: { data } }) => {
      //   let definitions = [];
      //   const stream_url = Object.keys(data);
      //   if (stream_url.length) {
      //     stream_url.forEach((key) => {
      //       if (data[key]) {
      //         definitions.push({
      //           code: key,
      //           label: this.getLabel(key),
      //           url: data[key],
      //         });
      //       }
      //     });
      //   }
      //   this.definitions = definitions;
      // });
    },
    chooseDefinition() {
      this.formInline.liveStream = this.formInline.definition;
    },
    doCopy(val) {
      this.$copyText(val).then(
        (e) => {
          this.$message.success(this.$t("video.copyAlready"));
        },
        (e) => {
          this.$message.error(this.$t("video.copyErr"), e.text);
        }
      );
    },
    confirm(formName) {
      console.log(this.activeCategory.title, "看一下什么情况呢");
      console.log("this.formInline: ", this.formInline);
      let id = this.formInline.session || this.match_id;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          post({
            // 获取推流地址
            url: "/api/live/editLive",
            data: {
              title: this.formInline.title, //標題 必填
              cateid: this.detail.categoryid, //直播分类 必填
              liveid: String(this.detail.liveid),
              match_id: id, // 比赛id
              thumb: this.formInline.imageUrl || "",
              pull_url: this.detail.pull_url, //播流地址 必填
              sport_type: this.setTitel(), //流名 必填
              ticket: Number(this.formInline.ticket) || 0,
            },
          }).then(({ data: { data } }) => {
            this.isTitle = this.formInline.title;
            this.$emit("updateLive");
            this.$emit("showToast", this.$t("info.updateSuccess"));
            this.resetForm(formName);
            this.reload();
          });
        } else {
          return false;
        }
      });
    },
    setTitel() {
      if (this.activeCategory === 1) {
        return "football";
      } else if (this.activeCategory === 2) {
        return "basket";
      } else {
        return "tennis";
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.imageUrl = "";
      this.formInline.match = "";
      this.formInline.session = "";
      this.formInline.liveStream = "";
      this.formInline.imageUrl = "";
      this.$emit("setIsShowLive", false);
    },

    handleAvatarSuccess(res, file) {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      //this.formLive.imageUrl = `https://sport.sun8tv.com${res.data[0]}`;
      const { img_upload_url } = this.appConfig;
      if (
        typeof res != "undefined" &&
        res.status == 0 &&
        res.data &&
        res.data.length
      ) {
        let imgurl = "";
        if (res.data[0]) {
          imgurl = `${img_upload_url}${res.data[0]}`;
        }
        this.formInline.imageUrl = imgurl;
      }
      this.upLoading = false;
      this.$refs["ruleForm"].clearValidate("imageUrl");
    },
    handleAvatarSuccessVertical(res, file) {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      this.imageUrl_v = URL.createObjectURL(file.raw);
      //  this.formLive.imageUrl_v = `https://sport.sun8tv.com${res.data[0]}`;
      const { img_upload_url } = this.appConfig;
      if (
        typeof res != "undefined" &&
        res.status == 0 &&
        res.data &&
        res.data.length
      ) {
        let imgurl = "";
        if (res.data[0]) {
          imgurl = `${img_upload_url}${res.data[0]}`;
        }
        this.formInline.imageUrl_v = imgurl;
      }
      this.upLoading_v = false;
      this.$refs["ruleForm"].clearValidate("imageUrl_v");
    },
    beforeAvatarUploadVertical(file) {
      return this.beforeUpload(file, true);
    },
    handleUpload(res) {
      const file = res.file;
      console.log("handleUpload", file);

      if (this.setTimer) {
        clearTimeout(this.setTimer);
        this.setTimer = null;
      }

      this.upload(file)
        .then((res) => {
          console.log(res, "res");
          if (res.status === 0) {
            this.formInline.imageUrl = res.data;
            this.imageUrl = res.data;
          }
        })
        .finally((err) => {
          this.$refs["ruleForm"].clearValidate("imageUrl");
          this.upLoading = false;
          console.log(err);
        });
    },
    beforeAvatarUpload(file) {
      return this.beforeUpload(file, false);
    },
    beforeUpload(file, flag) {
      const flieArr = file.name.split("."); // 根据.分割数组
      let suffix = flieArr[flieArr.length - 1]; // 取最后一个
      const isJPG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isBMP = file.type === "image/bmp";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if ((!isJPG && !isGIF && !isPNG && !isBMP) || suffix == "jfif") {
        this.$message.error(this.$t("video.imgFo"));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$t("video.imgErr"));
      }
      if (flag) {
        this.upLoading_v = true;
      } else {
        this.upLoading = true;
      }
      this.setTimer = setTimeout(() => {
        this.upLoading_v = false;
        this.upLoading = false;
      }, 3000);
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    removeImage(id) {
      if (id) {
        this.imageUrl_v = "";
        this.formInline.imageUrl_v = "";
      } else {
        this.imageUrl = "";
        this.formInline.imageUrl = "";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.liveMatchesTwoTitleDialog {
  border-radius: 8px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  overflow: hidden;
	/deep/ .el-dialog {
	  border-radius: 8px;
	}

	/deep/ .el-dialog__title {
	  font-weight: 500;
	  color: #333333;
	}

	/deep/ .el-dialog__headerbtn {
	  font-size: 24px;
	}

	.append_text {
	  font-size: 14px;
	  color: rgba(208, 45, 84, 1);
	  cursor: pointer;
	}
	.append_text {
	    font-size: 14px;
	    color: rgba(208, 45, 84, 1);
	    cursor: pointer;
	    margin-left: 11px;
	}
	.pull-stream {
	    display: flex;
	    width: 300px;
	    background-color: #f5f7fa;
	    border-color: #e4e7ed;
	    color: #c0c4cc;
	    cursor: not-allowed;
	    height: 32px;
	    // line-height: 32px;
	    border-radius: 4px;
	    border: 1px solid #dcdfe6;
	    outline: none;
	    padding: 0 15px;
	    box-sizing: border-box;
			justify-content: space-between;
			align-items : center;
			span{
				line-height : 32px;
			}
	}
	.upload-demo {
	    width: 160px;
	    height: 90px;
	    line-height: 24px;
	    display: flex;
	    justify-content: center;
	    align-items: center;
			background : #F9F9FB;
	    border: solid 1px #d5d5d5;
	    border-radius: 4px;
	    position: relative;
			.upload-text{
				color : rgba(208, 45, 84, 1);
			}
	}

	.upload-demo-v {
	    width: 68px;
	    height: 90px;
	}

	.imgurl {
	    // margin-top: 7px;
	    border-radius: 4px;
	}

	.append_text {
	    font-size: 14px;
	    color: rgba(208, 45, 84, 1);
	    cursor: pointer;
	    margin-left: 11px;
	}
	.del {
	    width: 100%;
	    position: absolute;
	    top: 0;
	    font-size: 14px;
	    color: rgba(208, 45, 84, 1);
	    text-align: left;
	}


	.el-upload__text {
		width: 220px;
		position: absolute;
		bottom: 0;
		color: #ccc;
		line-height: 22px;
		text-align: left;
		font-size : 12px;
		.size {
				color: #666666;
		}
		.format {
				color: #999;
		}
	}

	/deep/ {
		.el-dialog__header{
			border-bottom : 1px solid #f7f7f7;
		}
		.el-dialog__body{
			padding-bottom : 10px;
		}
		.el-dialog__footer{
			padding-bottom : 25px;
		}
	}
	.dialog-footer {
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  padding: 0 4px;
	  .btn {
	    width: 190px;
	    height: 40px;
	    font-size: 18px;
	    text-align: center;
	    line-height: 40px;
	    cursor: pointer;
	    box-sizing: border-box;
	    border-radius: 20px;
	  }

	    .cancle_btn {
	        color: #666666;
	        background: #FFFFFF;
	        border-radius: 10px;
	        margin-right: 24px;
					border: 1px solid rgba(208, 45, 84, 1)
					color : rgba(208, 45, 84, 1);
	    }

	    .confirm_btn {
	        color: #ffffff;
	        background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);
	        border-radius: 5px;

	    }
	}
}
</style>
